import { Link } from 'react-router-dom';
import '../styles/Legal.css';

const PrivacyPolicy = () => {
  return (
    <>
      <section className="legal-header">
        <div className="legal-title-container">
          <div className="legal-badge">
            <span>🔒 Your Trust Matters</span>
          </div>
          <h1 className="legal-title">
            <span>Privacy</span> Policy
          </h1>
          <div className="legal-effective">
            Effective Date: <strong>March 20, 2026</strong> | Last Updated: <strong>March 20, 2026</strong>
          </div>
        </div>
      </section>

      <section className="legal-content">
        <div className="legal-card">
          <div className="legal-section">
            <h2>1. Introduction</h2>
            <p>Welcome to Olitask ("we," "our," or "us").</p>
            <p>Olitask is a platform that connects users to request and provide services, including task assistance, transportation-related services, and other on-demand activities.</p>
            <p>Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile applications, websites, APIs, and related services.</p>
          </div>

          <div className="legal-section">
            <h2>2. Eligibility</h2>
            <p>Olitask is intended only for users aged 18 and older.</p>
            <p>We do not knowingly collect data from individuals under 18. If discovered, such data will be deleted immediately.</p>
          </div>

          <div className="legal-section">
            <h2>3. Information We Collect</h2>
            <h3>Personal Information:</h3>
            <ul className="legal-list">
              <li>Name, email, phone number</li>
              <li>Profile photo, date of birth, gender (optional)</li>
              <li>Address and identity verification documents</li>
            </ul>
            <h3>Account Data:</h3>
            <ul className="legal-list">
              <li>Roles, skills, ratings, task history</li>
            </ul>
            <h3>Payment Information:</h3>
            <ul className="legal-list">
              <li>Processed via Stripe (no full card storage)</li>
              <li>Transaction history and payout details</li>
            </ul>
            <h3>Location Data:</h3>
            <ul className="legal-list">
              <li>Real-time GPS for tasks and navigation</li>
            </ul>
            <h3>Device Data:</h3>
            <ul className="legal-list">
              <li>Device type, OS, IP address, logs</li>
            </ul>
            <h3>Communications:</h3>
            <ul className="legal-list">
              <li>Chat messages, support requests</li>
            </ul>
            <h3>Uploaded Content:</h3>
            <ul className="legal-list">
              <li>Photos and documents</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. How We Use Your Information</h2>
            <ul className="legal-list">
              <li>Account creation and management</li>
              <li>Identity verification</li>
              <li>Task matching and fulfillment</li>
              <li>Payment processing</li>
              <li>Customer support</li>
              <li>Notifications and alerts</li>
              <li>Fraud prevention and security</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>5. Sharing of Information</h2>
            <ul className="legal-list">
              <li>Other users (limited profile/task info)</li>
              <li>Service providers (Stripe, cloud hosting)</li>
              <li>Legal compliance</li>
              <li>Business transfers</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>6. Data Security</h2>
            <p>We use encryption, secure authentication, and monitoring. No system is 100% secure.</p>
          </div>

          <div className="legal-section">
            <h2>7. Data Retention</h2>
            <p>We retain data while your account is active and as required for legal and operational purposes.</p>
          </div>

          <div className="legal-section">
            <h2>8. Your Rights</h2>
            <p>You may access, correct, delete, or restrict your data depending on your jurisdiction.</p>
          </div>

          <div className="legal-section">
            <h2>9. California Privacy Rights</h2>
            <p>California residents may request access, deletion, and opt-out (we do not sell data).</p>
          </div>

          <div className="legal-section">
            <h2>10. Account Deletion</h2>
            <p>Request deletion via app settings or email <a href="mailto:privacy@oliveeb.com">privacy@oliveeb.com</a>. Some data may be retained for compliance.</p>
          </div>

          <div className="legal-section">
            <h2>11. Cookies &amp; Tracking</h2>
            <p>We use cookies and analytics tools to improve user experience.</p>
          </div>

          <div className="legal-section">
            <h2>12. Third-Party Services</h2>
            <p>Includes Stripe, Google Maps, and authentication providers.</p>
          </div>

          <div className="legal-section">
            <h2>13. Children's Privacy</h2>
            <p>Users under 18 are not allowed on the platform.</p>
          </div>

          <div className="legal-section">
            <h2>14. Changes to Policy</h2>
            <p>We may update this policy and notify users via app or email.</p>
          </div>

          <div className="legal-section">
            <h2>15. Contact</h2>
            <div className="contact-block">
              <div className="contact-info">
                <strong>Oliveeb, Inc.</strong>
                <span>Email: <a href="mailto:help@oliveeb.com">help@oliveeb.com</a></span>
                <span>Website: <a href="https://www.oliveeb.com" target="_blank" rel="noopener noreferrer">https://www.oliveeb.com</a>, <a href="https://www.olitask.com" target="_blank" rel="noopener noreferrer">https://www.olitask.com</a></span>
              </div>
              <Link to="/contact-us.html" className="contact-badge">
                Contact support
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;